import { Action } from '@ngrx/store';
import { AuthUserInfo } from '@shared/models/auth.model';
import { ErrorResponse } from '@shared/models/error.model';

import { ClientIdTypeEnum } from '../../enum/client-id.enum';
import { ChangePasswordRequest, ChangePasswordResponse } from '../../models/force-change-password.model';

export enum UserActionTypes {
  USER_INFO = '[User] User Info',
  USER_CLIENT_ID = '[User] Client ID',
  USER_INFO_RESET = '[User] User Info Reset',
  USER_PASSWORD_RESET = '[User] User Password Reset',

  CHANGE_PASSWORD_REQUEST = '[Force Change Password] ChangePassword Request',
  CHANGE_PASSWORD_SUCCESS = '[Force Change Password] ChangePassword Success',
  CHANGE_PASSWORD_FAILED = '[Force Change Password] ChangePassword Failed',
  CHANGE_PASSWORD_RESET = '[Force Change Password] ChangePassword Reset'
}

export class UserInformationAction implements Action {
  readonly type = UserActionTypes.USER_INFO;

  constructor(public payload: AuthUserInfo) {}
}

export class ClientIdAction implements Action {
  readonly type = UserActionTypes.USER_CLIENT_ID;

  constructor(public payload: ClientIdTypeEnum | null) {}
}

export class UserInformationResetAction implements Action {
  readonly type = UserActionTypes.USER_INFO_RESET;

  constructor() {}
}

export class UserPasswordResetAction implements Action {
  readonly type = UserActionTypes.USER_PASSWORD_RESET;

  constructor(public payload: { userName: string; merchant: string }) {}
}

export class ChangePasswordRequestAction implements Action {
  readonly type = UserActionTypes.CHANGE_PASSWORD_REQUEST;

  constructor(public payload: ChangePasswordRequest) {}
}

export class ChangePasswordSuccess implements Action {
  readonly type = UserActionTypes.CHANGE_PASSWORD_SUCCESS;

  constructor(public payload: ChangePasswordResponse) {}
}

export class ChangePasswordFailed implements Action {
  readonly type = UserActionTypes.CHANGE_PASSWORD_FAILED;

  constructor(public payload: ErrorResponse) {}
}

export class ChangePasswordReset implements Action {
  readonly type = UserActionTypes.CHANGE_PASSWORD_RESET;
  constructor() {}
}

export type UserInfoActions =
  | ChangePasswordRequestAction
  | ChangePasswordSuccess
  | ChangePasswordFailed
  | ChangePasswordReset
  | UserInformationAction
  | ClientIdAction
  | UserInformationResetAction
  | UserPasswordResetAction;
